export default "__VITE_ASSET__CktrzGD___"